import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, User, LogOut, Diamond } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';

const navItems = [
  { id: 'weddings', label: 'My Weddings', icon: Heart },
  { id: 'account', label: 'Account', icon: User },
];

const DashboardSidebar = ({ activeTab, onTabChange }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="w-64 bg-[#FFFFF0] border-r border-[#E6D8AD] flex flex-col justify-between shrink-0 z-20 h-screen sticky top-0 shadow-[4px_0_24px_rgba(0,0,0,0.02)]">
      <div className="p-8">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-12 justify-center">
          <Diamond className="w-8 h-8 text-[#D4AF37]" fill="#D4AF37" />
          <div className="flex flex-col text-center">
            <h1
              className="text-2xl font-bold tracking-widest text-[#36454F] leading-none uppercase"
              style={{ fontFamily: "'Cinzel', serif", letterSpacing: '0.15em' }}
            >
              Our Day
            </h1>
            <span className="text-[0.6rem] text-[#D4AF37] uppercase tracking-[0.2em] mt-1">
              Partner Panel
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex flex-col gap-3">
          {navItems.map((item) => {
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={`flex items-center gap-4 px-4 py-3 rounded-r-lg transition-all duration-300 text-left w-full ${
                  isActive
                    ? 'text-[#36454F] border-r-[3px] border-[#D4AF37]'
                    : 'text-[#54626F] hover:text-[#36454F]'
                }`}
                style={{
                  background: isActive
                    ? 'linear-gradient(90deg, rgba(212,175,55,0.2) 0%, transparent 100%)'
                    : undefined,
                }}
              >
                <item.icon className={`w-5 h-5 ${isActive ? 'text-[#D4AF37]' : ''}`} />
                <span className="font-medium tracking-wide text-sm uppercase" style={{ fontFamily: "'Lato', sans-serif" }}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Logout */}
      <div className="p-8 border-t border-[#E6D8AD]/50">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 w-full text-left text-[#54626F] hover:text-[#D4AF37] transition-colors"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium text-sm uppercase tracking-wide" style={{ fontFamily: "'Lato', sans-serif" }}>
            Log out
          </span>
        </button>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
